// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, Fragment} from 'react';
import {useTranslation, Trans as T} from 'react-i18next';
import cn from 'classnames';
import {capitalize} from 'zstring';
// @ts-ignore
import {format_price} from '/util/country.js';
// @ts-ignore
import {get_price_plan} from '../../../../svc/account/pub/membership.js';
import {Button} from '../../../shared/button';
import {Settings_context} from '../settings_ctx';
import styles from './short_plan.module.less';
import {i_plan} from './plus_types';

interface i_short_plan_props {
    plan: i_plan;
    bogof?: boolean;
    currency: string;
    on_click: (plan:i_plan)=>void;
    button_title?: string;
}

export const Short_plan = (props:i_short_plan_props)=>{
    const {theme} = useContext(Settings_context);
    const {plan, currency, bogof, button_title, on_click} = props;
    const {t} = useTranslation() as any;
    const price_o = get_price_plan(plan, currency);
    const {month_price, regular_price, price} = price_o;
    const pricing_regular = bogof ? <span className={styles.regular}>
      {format_price(currency, 2*regular_price)}
    </span> : regular_price && regular_price!=price ? <span
      className={styles.regular}>
      {format_price(currency, regular_price)}
    </span> : null;
    const pricing_text = bogof ? <Fragment>
          for 2 {capitalize(plan.every)}s*
        </Fragment> : `billed every ${plan.every}`;
    const handle_click = ()=>on_click(plan);
    const cls = cn(styles.plan, bogof && styles.plan_bogof);
    return <div className={cls} onClick={handle_click}>
      <div className={styles.body}>
        {bogof && <div className={cn(styles.badge, styles.bogof_badge)}>
          <p className={theme.xs}><T>BOGOF</T></p>
        </div>}
        <div className={styles.grid}>
          <div className={styles.text_block}>
            <div className={styles.name}>
              <p className={theme.bold}>
                <b><T>{plan.short_name} plan</T></b>
              </p>
              {bogof && <p className={cn(theme.p2, styles.one_more)}>
                <T>+ 1 {capitalize(plan.every)} FREE</T>
              </p>}
            </div>
            <div className={styles.monthly_price}>
              <h2>{format_price(currency, month_price)}</h2>
              <p>/ {t('month')}</p>
            </div>
            <div className={styles.pricing}>
              <p className={theme.xs}>
                {pricing_regular}
                <span className={styles.price}>
                  {format_price(currency, price)}
                </span>
                <span><T>{pricing_text}</T></span>
              </p>
            </div>
          </div>
          <div className={styles.button_block}>
            <Button round arrow caption={t(button_title || 'Select')} w100
              size={'sm'} cls={styles.btn} on_click={handle_click}/>
          </div>
        </div>
      </div>
    </div>;
};
